import {
  fabric
} from 'fabric'
const extend = fabric.util.object.extend
const matrices = {
  Brownie: [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0],
  Vintage: [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0],
  Kodachrome: [
    1.12855,
    -0.39673,
    -0.03992,
    0,
    0.24991,
    -0.16404,
    1.08352,
    -0.05498,
    0,
    0.09698,
    -0.16786,
    -0.56034,
    1.60148,
    0,
    0.13972,
    0,
    0,
    0,
    1,
    0
  ],
  Technicolor: [
    1.91252,
    -0.85453,
    -0.09155,
    0,
    0.04624,
    -0.30878,
    1.76589,
    -0.10601,
    0,
    -0.27589,
    -0.2311,
    -0.75018,
    1.84759,
    0,
    0.12137,
    0,
    0,
    0,
    1,
    0
  ],
  Polaroid: [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0],
  Pinker: [2, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
  NewYork: [1, -0.1, 0.3, 0, 0, 0.2, 0.8, 0.1, 0, 0, 0, 0.3, 1, 0, 0, 0, 0, 0, 1, 0],
  Dallas: [1, 0, 0, 0, 0, 0.2, 1, -0.2, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 0],
  NewDallas: [1, 0, 0, 0, -0.02, 0.3, 1, -0.3, 0, -0.02, 0, 0, 1, 0, -0.02, 0, 0, 0, 1, 0],
  Umbrella: [1, 0, 0, 0, -0.01, 0.2, 1, -0.2, 0, 0, 0, -0.2, 1, 0.2, 0, 0, 0, 0, 1, 0],
  Oldies: [0, 0.76, 0, 0, 0.07, 0, 0.76, 0, 0, 0.02, 0, 0.76, 0, 0, -0.01, 0, 0.11, 0, 1.66, 0],
  Legend: [0.43, 0.77, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0.2, 0, 0, 0, 0, 1, 0],

  Kevin: [
    //red
    0.9,
    -0.042,
    -0.003,
    -0.54,
    0,
    //green
    0.84,
    -0.047,
    -0.042,
    -0.003,
    0,
    //blue
    -0.037,
    0.42,
    0.7,
    -0.32,
    0,
    //alpha
    0,
    0,
    0,
    1,
    0
  ],

  BlackWhite: [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0],
  GrayScale: [
    0.2225, 0.7169, 0.0606, 0, 0,
    0.2225, 0.7169, 0.0606, 0, 0,
    0.2225, 0.7169, 0.0606, 0, 0,
    0, 0, 0, 1, 0
  ],

  Sep: [0.393,
    0.769,
    0.189,
    0,
    0,
    0.349,
    0.686,
    0.168,
    0,
    0,
    0.272,
    0.534,
    0.131,
    0,
    0,
    0,
    0,
    0,
    1,
    0
  ]

}

const BASE_MATRIX = [
  1, 0, 0, 0, 0,
  0, 1, 0, 0, 0,
  0, 0, 1, 0, 0,
  0, 0, 0, 1, 0
]
fabric.Image.filters.ColorEffect = fabric.util.createClass(fabric.Image.filters.ColorMatrix, {
  /**
   * Filter type
   */
  type: 'ColorEffect',

  color: 'Sepia',
  factor: 1,
  /**
   * Colormatrix for the effect
   * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
   * outside the -1, 1 range.
   * @param {Array} matrix array of 20 numbers.
   * @default
   */

  initialize: function ({
    color,
    factor = 1,
  }) {
    this.color = color || this.color
    this.factor = factor || this.factor
    const targetMatrix = matrices[this.color]
    const transformedMatrix = targetMatrix.map((value, index) => {
      const subResult = BASE_MATRIX[index] - value
      const multiplyResult = subResult * factor
      return BASE_MATRIX[index] - multiplyResult
    })
    this.matrix = transformedMatrix
  },

  /**
   * Lock the matrix export for this kind of static, parameter less filters.
   */
  mainParameter: 'color',
  /**
   * Lock the colormatrix on the color part, skipping alpha
   */
  colorsOnly: true,

  /**
   * Returns object representation of an instance
   */
  toObject: function () {
    return extend(this.callSuper('toObject'), {
      color: this.color,
      factor: this.factor
    })
  }
})

fabric.Image.filters.ColorEffect.fromObject = fabric.Image.filters.BaseFilter.fromObject

const ColorEffect = fabric.Image.filters.ColorEffect
export {
  ColorEffect
}



// WEBPACK FOOTER //
// ./src/model/pixel/customfilter/ColorEffect.js